<template>
  <div>
    <b-alert v-if="errorMessage" show variant="danger">{{ errorMessage }}</b-alert>

    <b-table
      :items="items"
      :fields="fields"
      :busy="loading"
      primary-key="month"
      responsive
      hover
      show-empty
      empty-text="Sin comisiones."
    >
      <template #table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
        </div>
      </template>

      <template #cell(base)="{ item }">{{ money(item.base) }}</template>
      <template #cell(elite)="{ item }">{{ money(item.elite) }}</template>
      <template #cell(patient_flow)="{ item }">{{ money(item.patient_flow) }}</template>
      <template #cell(clawback)="{ item }">{{ money(item.clawback) }}</template>
      <template #cell(total)="{ item }"><strong>{{ money(item.total) }}</strong></template>

      <template #cell(status)="{ item }">
        <b-badge :variant="badge(item.status).variant">{{ badge(item.status).text }}</b-badge>
        <div class="small text-muted">{{ statusDetail(item) }}</div>
      </template>

      <template #cell(by_status)="{ item }">
        <div v-for="part in statusParts(item)" :key="part.key" class="small">
          {{ part.text }}: {{ money(part.amount) }}
        </div>
      </template>
    </b-table>

    <PaginationTable
      :dataMeta="dataMeta"
      :totalUsers="total"
      :perPage="perPage"
      :currentPage="currentPage"
      @page-changed="load"
    />
  </div>
</template>

<script>
import { BAlert, BBadge, BSpinner, BTable } from 'bootstrap-vue'
import agentPlanService from '@/core/services/api/agentPlan'
import PaginationTable from '@/components/PaginationTable'
import { COMMISSION_STATUS_COPY, money, statusBadge } from '@/core/utils/agentPlanDashboard'
import pagedList from './pagedList'

/** Comisiones por mes. agency=true muestra la comisión propia de la agencia. */
export default {
  name: 'CommissionMonthsTable',
  components: { BAlert, BBadge, BSpinner, BTable, PaginationTable },
  mixins: [pagedList],
  props: {
    agency: { type: Boolean, default: false },
  },
  data() {
    return {
      fields: [
        { key: 'month', label: 'Mes' },
        { key: 'base', label: 'Base' },
        { key: 'elite', label: 'Élite' },
        { key: 'patient_flow', label: 'PatientFlow' },
        { key: 'clawback', label: 'Descuentos' },
        { key: 'total', label: 'Total' },
        { key: 'status', label: 'Estado' },
        { key: 'by_status', label: 'Por estado' },
      ],
    }
  },
  methods: {
    money,
    fetchPage(params) {
      return this.agency ? agentPlanService.getAgencyCommissions(params) : agentPlanService.getCommissions(params)
    },
    badge(status) {
      return statusBadge(COMMISSION_STATUS_COPY, status)
    },
    statusDetail(item) {
      if (item.status === 'paid') return item.paid_at ? `Pagada el ${item.paid_at}` : ''
      return item.payable_on ? `Se paga el ${item.payable_on}` : ''
    },
    statusParts(item) {
      const byStatus = item.by_status || {}
      return Object.keys(COMMISSION_STATUS_COPY)
        .filter((key) => Number(byStatus[key]))
        .map((key) => ({ key, text: COMMISSION_STATUS_COPY[key].text, amount: byStatus[key] }))
    },
  },
}
</script>
